import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';

interface SectionHeaderProps {
  title: string;
  description?: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
}

export function SectionHeader({ title, description, buttonLabel, onButtonClick }: SectionHeaderProps) {
  return (
    <div className="flex justify-between items-center">
      <div>
        <h3 className="text-lg font-semibold">{title}</h3>
        {description && <p className="text-sm text-muted-foreground">{description}</p>}
      </div>
      {buttonLabel && onButtonClick && (
        <Button onClick={onButtonClick} className="gap-2">
          <Plus className="h-4 w-4" />
          {buttonLabel}
        </Button>
      )}
    </div>
  );
}
